export default {
  boxShadow: 'rgba(0, 0, 0, 0.1) 6px 6px 15px 7px',
  padding: {
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
  },
  border: {
    thickness: '0.1875rem',
  },
  title: {
    margin: {
      bottom: 0,
    },
  },
  inner: {
    padding: {
      top: '0.9375rem',
      right: '0.9375rem',
      bottom: '0.9375rem',
      left: '0.9375rem',
    },
  },
  outer: {
    margin: {
      top: '0.625rem',
      right: '0.625rem',
      bottom: '0.625rem',
      left: '0.625rem',
    },
    width: 'calc(50% - 1.25rem)',
  },
};
